import grabColor from 'src/utils/grabColor'
import styled from 'styled-components'

const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  position: absolute;
  inset: 0 0 auto 0;
  overflow: hidden;
  margin: 0 auto;
  &:before {
    content: '';
    width: ${({ percent }) => percent}%;
    height: 6px;
    background: ${grabColor('brand.DEFAULT')};
    position: absolute;
    top: 0;
    left: 0;
  }
`

export const InlineProgressBar = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 4px;
  background: ${grabColor('backgroundDark')};
  &:before {
    content: '';
    width: ${({ percent }) => percent}%;
    height: 8px;
    background: ${grabColor('brand.DEFAULT')};
    position: absolute;
    top: 0;
    left: 0;
  }
`

export default ProgressBar
